import { render, staticRenderFns } from "./WorkFactor.vue?vue&type=template&id=6fe2cf86&"
import script from "./WorkFactor.vue?vue&type=script&lang=js&"
export * from "./WorkFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports